import React from 'react'
import PropTypes from 'prop-types'

import createButtonContainer from './buttonContainer'

class NavButton extends React.Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown)
  }

  onClick(event) {
    const { selectItem, item } = this.props

    event.preventDefault()
    selectItem(item)
  }

  onKeyDown(event) {
    const { item, keyName } = this.props

    if (event.key === keyName && item) this.onClick(event)
  }

  render() {
    if (!this.props.item) return null

    return (
      <div onClick={this.onClick} className={this.props.className}>
        {this.props.children}
      </div>
    )
  }
}

NavButton.propTypes = {
  children: PropTypes.element.isRequired,
  selectItem: PropTypes.func.isRequired,
  item: PropTypes.object,
  keyName: PropTypes.string,
  className: PropTypes.string
}

export default createButtonContainer(NavButton)
